export default __webpack_public_path__ + "static/media/MakeGoldfishTank_03.e16795da.png";